export const ITEMS_PER_PAGE = 8;
export const ITEMS_PER_PEOPLE_PAGE = 20;
export const TMDB_ITEMS_PER_PAGE = 20;
export const TOTAL_PAGES = 500;
export const API_KEY = "e0da2a33c4def495d0c4977083b2de8b";